const cities = [
  {
    "city": "Ahmedabad",
    "state": "Gujarat",
    "lat": 23.0225,
    "lng": 72.5714
  },
  {
    "city": "Bengaluru",
    "state": "Karnataka",
    "lat": 12.9716,
    "lng": 77.5946
  },
  {
    "city": "Chandigarh",
    "state": "Chandigarh",
    "lat": 30.7333,
    "lng": 76.7794
  },
  {
    "city": "Chennai",
    "state": "Tamil Nadu",
    "lat": 13.0827,
    "lng": 80.2707
  },
  {
    "city": "Delhi NCR",
    "state": "Delhi",
    "lat": 28.7041,
    "lng": 77.1025
  },
  {
    "city": "Goa",
    "state": "Goa",
    "lat": 15.2993,
    "lng": 74.1240
  },
  {
    "city": "Hyderabad",
    "state": "Telangana",
    "lat": 17.3850,
    "lng": 78.4867
  },
  {
    "city": "Jaipur",
    "state": "Rajasthan",
    "lat": 26.9124,
    "lng": 75.7873
  },
  {
    "city": "Kolkata",
    "state": "West Bengal",
    "lat": 22.5726,
    "lng": 88.3639
  },
  {
    "city": "Mumbai",
    "state": "Maharashtra",
    "lat": 19.0760,
    "lng": 72.8777
  },
  {
    "city": "Pune",
    "state": "Maharashtra",
    "lat": 18.5204,
    "lng": 73.8567
  },
  {
    "city": "Surat",
    "state": "Gujarat",
    "lat": 21.1702,
    "lng": 72.8311
  }
];

export default cities;